<template>
  <div class="update-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t("commonMsg.new") }}</span>
      <span v-else>{{ $t("commonMsg.edit") }}</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap params-wrap">
        <el-form
          label-width="120px"
          :model="form"
          @submit.native.prevent
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item label="分组名称" prop="name">
            <el-input
              v-model.trim="form.name"
              class="fl"
              style="width: 300px"
              placeholder="输入名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="设备型号">
            <ul>
              <li
                class="modelGroup-item"
                v-for="(item, index) in devicesModel"
                :key="index"
              >
                <el-input
                  type="text"
                  v-model.trim="item.model"
                  placeholder="输入型号"
                />
                <div class="modelGroup-item-btn">
                  <i
                    class="el-icon-plus"
                    v-if="index === devicesModel.length - 1"
                    @click="addParam"
                    title="添加项"
                  ></i>

                  <i
                    class="el-icon-minus"
                    v-if="index > 0"
                    @click="deleteParam(index)"
                    title="删除项"
                  ></i>
                </div>
              </li>
            </ul>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        models: [],
      },
      devicesModel: [{ model: "" }],
      rules: {
        name: [
          {
            required: true,
            message: "名称不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    async getDetails() {
      let res = await this.$http.getCollegeModelGroupDetail(this.$route.query.id);
      this.devicesModel = [];
      this.form.name = res.data.name;
      for (let model of res.data.models) {
        this.devicesModel = [...this.devicesModel, { model }];
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.form.models = [];
          for (let item of this.devicesModel) {
            this.form.models = [...this.form.models, item.model];
          }
          if (!this.form.models.length) {
            this.elMsg("请至少添加一个型号", "warning");
            return;
          }
          if (this.$route.query.id) {
            this.edit();
          } else {
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    async create() {
      try {
        if (this.$route.query.id) {
          await this.$http.updateCollegeModelGroup(this.$route.query.id, this.form);
        } else {
          await this.$http.createCollegeModelGroups(this.form);
        }
        this.elMsg(this.$t("alertMsg.saveSuccess"), "success");
        this.$router.back();
      } catch (error) {
        this.elMsg(this.$t("alertMsg.saveFailure"), "error");
      }
    },
    async edit() {
      try {
        await this.$http.updateCollegeModelGroup(this.$route.query.id, this.form);
        this.elMsg(this.$t("alertMsg.saveSuccess"), "success");
        this.$router.back();
      } catch (error) {
        this.elMsg(this.$t("alertMsg.saveFailure"), "error");
      }
    },

    addParam() {
      const obj = {
        model: "",
      };
      this.devicesModel = [...this.devicesModel, obj];
    },

    deleteParam(index) {
      this.devicesModel.splice(index, 1);
    },
  },
  mounted() {
    if (this.$route.query.id) {
      this.getDetails();
    }
  },
};
</script>

<style lang="scss">
.update-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    &.params-wrap {
      ul.parms-list {
        margin-top: 0;
      }
      .el-form-item--small .el-form-item__content {
        float: left;
        margin-left: 0 !important;
      }
    }
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .update-import-btn {
        margin-top: 10px;
      }
      .update-upload-progress {
        display: flex;
        align-items: center;
        > .el-progress__text {
          /* width: 100px; */
        }
      }
    }
  }
}
.modelGroup-item {
  position: relative;
  margin-bottom: 20px;
  .modelGroup-item-btn {
    width: 40px;
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 50%;
    right: -50px;
    transform: translate(0, -50%);
    > i {
      cursor: pointer;
    }
  }
}
</style>
